import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getProductsOnCategory } from '../../redux/Slices/ProductSlice'
import { useParams } from 'react-router-dom'
import { getOneCategory } from '../../redux/Slices/CategorySlice'

const UseProductOnCategory = () => {
    const dispatch = useDispatch()
    const limit = 10;
    const { catid } = useParams()
    const [loading, setLoading] = useState(true)
    const [pageLoading, setpageLoading] = useState(true)
    const [CategoryNameloading, setCategoryNameloading] = useState(true)
    const [CategoryName, setCategoryName] = useState("")
    const [categoryProducts, setCategoryProducts] = useState([])
    const [pagescount, setPagescount] = useState()
    const { ProductsOnCategoryList } = useSelector(state => state.ProductReducer)
    const { OneCategory } = useSelector(state => state.CategoryReducer)

    // handle get products based on category
    const handleGetProductsOnCategory = async () => {
        setLoading(true)
        await dispatch(getProductsOnCategory({ CatId: catid, limit: limit, page: 1 }))
        setLoading(false)
    }

    // to run the handle get products on category
    useEffect(() => {
        handleGetProductsOnCategory()
    }, [])


    // onPress 
    const onPress = async (page) => {
        setpageLoading(true)
        await dispatch(getProductsOnCategory({ CatId: catid, limit: limit, page: page }))
        setpageLoading(false)
    };


    // handle response based on loading
    useEffect(() => {
        if (loading === false && ProductsOnCategoryList && ProductsOnCategoryList.status === 200 && ProductsOnCategoryList.data.data) {
            setCategoryProducts(ProductsOnCategoryList.data.data);
            setPagescount(ProductsOnCategoryList.data.paginationResult.numberOfPages);
            localStorage.setItem("CategoryArray", catid)
            let categoriesValue = `category[in][]=${catid}&`;
            localStorage.setItem("categoriesChecked", categoriesValue)
        }
    }, [loading]);

    // handle response based on loading
    useEffect(() => {
        if (pageLoading === false && ProductsOnCategoryList && ProductsOnCategoryList.status === 200 && ProductsOnCategoryList.data.data) {
            setCategoryProducts(ProductsOnCategoryList.data.data);
            setPagescount(ProductsOnCategoryList.data.paginationResult.numberOfPages);
            localStorage.setItem("CategoryArray", catid)
            let categoriesValue = `category[in][]=${catid}&`;
            localStorage.setItem("categoriesChecked", categoriesValue)
        }
    }, [pageLoading]);

    // dispatch to get the category name
    const getCategoryName = async () => {
        setCategoryNameloading(true)
        await dispatch(getOneCategory(catid))
        setCategoryNameloading(false)
    }

    // run get category name function
    useEffect(() => {
        getCategoryName()
    }, [])

    // handle get category name request response 
    useEffect(() => {
        if (CategoryNameloading === false) {
            if (OneCategory && OneCategory.status === 200 && OneCategory.data) {
                setCategoryName(OneCategory.data.data.name)
            }
        }
    }, [CategoryNameloading])


    return [categoryProducts, pagescount, onPress, loading, CategoryName]
}

export default UseProductOnCategory
